import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import React, { useState } from "react";
import SharedPreferences from "../../core/utils/SharedPreferences";
import { STORAGE_KEYS } from "../../data/constant/Constants";
import { ROUTE_ENDPOINTS } from "../../data/constant/RouteConstants";
import LoginView from "../pages/login/LoginView";
import { HomeView } from "../pages/home/HomeView";
import { Backdrop, Box, CircularProgress, Stack } from "@mui/material";
import { CustomTextView } from "../component/CustomTextView";
import { COLOR_BLACK, COLOR_WHITE } from "../../data/colors/Colors";

export default function Router() {
  const getShowLoading = () =>
    SharedPreferences.getBoolean(STORAGE_KEYS.SHOW_LOADING) == true;
  const getLoginToken = () =>
    SharedPreferences.getString(STORAGE_KEYS.TOKEN) !== null;

  const [isLoggedIn, setIsLoggedIn] = useState(getLoginToken());

  window.addEventListener(STORAGE_KEYS.TOKEN, () => {
    setIsLoggedIn(getLoginToken());
  });

  const [showLoading, setShowLoading] = useState(getShowLoading());

  window.addEventListener(STORAGE_KEYS.SHOW_LOADING, () => {
    setShowLoading(getShowLoading());
  });

  function PublicRoute(path: string, element: React.ReactNode) {
    return (
      <Route
        path={path}
        element={
          isLoggedIn ? <Navigate to={ROUTE_ENDPOINTS.HOME} /> : element
        }
      />
    );
  }

  function AuthRoute(path: string, element: React.ReactNode) {
    return (
      <Route
        path={path}
        element={isLoggedIn ? element : <Navigate to={ROUTE_ENDPOINTS.LOGIN} />}
      />
    );
  }

  return (
    <Box>
      <Backdrop
        open={showLoading}
        sx={{
          color: COLOR_BLACK,
          zIndex: (theme) => theme.zIndex.drawer + 999,
        }}
      >
        <Stack alignItems={"center"} gap={2}>
          {showLoading && (
            <>
              <CircularProgress sx={{ color: COLOR_WHITE }} size={40} />
              <CustomTextView
                text={"Loading..."}
                textColor={COLOR_WHITE}
                variant="h6"
                fontWeight="bold"
              />
            </>
          )}
        </Stack>
      </Backdrop>
      <BrowserRouter>
        <Routes>
          {PublicRoute(ROUTE_ENDPOINTS.LOGIN, <LoginView />)}
          {AuthRoute(ROUTE_ENDPOINTS.HOME, <HomeView />)}
          <Route path="*" element={<Navigate to={ROUTE_ENDPOINTS.LOGIN} />} />
        </Routes>
      </BrowserRouter>
    </Box>
  );
}
